import { GridDataService } from './grid-data.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { MessageHandlerService } from '../../utility/message-handler.service';

@Injectable()
export class AssessmentListService extends GridDataService
{
    constructor(http: HttpClient, translate: TranslateService, messageHandlerService: MessageHandlerService)
    {
        super(http, '/assessments', translate, messageHandlerService);
    }
}
